import find from 'lodash/find'

export default {
  props: {
    id: {
      type: [Number, String]
    }
  },
  data () {
    return {
      provider: null
    }
  },
  computed: {
    embedUrl () {
      return this.getFullUrl(this.$router.resolve({ name: 'provider.embed' }).href)
    }
  },
  mounted () {
    this.findProvider()
  },
  watch: {
    id () {
      this.findProvider()
    }
  },
  methods: {
    findProvider() {
      let id = this.$route.params.url
      let provider = find(this.$store.state.providers.all, ['url', id])
      this.$set(this, 'provider', provider)
    }
  }
}
